import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const LtiConsumingPlatformSchema = withDefaults({
  type: DataTypeLti.ConsumingPlatform,
  legacy: true,
  identity: {
    kind: '@id',
    name: 'id',
  },
  fields: [
    { kind: 'attribute', name: 'name', type: 'string' },
    { kind: 'attribute', name: 'description', type: 'string' },
    { kind: 'attribute', name: 'clientId', type: 'string' },
    { kind: 'attribute', name: 'platformData' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'hasMany',
      name: 'consumedTools',
      type: DataTypeLti.ConsumedTool,
      options: {
        async: true,
        inverse: 'consumingPlatform',
      },
    },
  ],
});
